export const isLast = <T extends unknown>(line: T, lines: T[]) => {
	return line === lines[lines.length - 1];
};
